var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-img',{style:(("width: " + _vm.width + "%; height: " + _vm.height + "%")),attrs:{"fluid":"","src":_vm.imgUrl,"alt":"Btn Manual","rounded":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }